// extracted by mini-css-extract-plugin
export default {"backdrop":"AddNewFile_backdrop__EIwEg","z_index_100":"AddNewFile_z_index_100__93Jkq","modal_title":"AddNewFile_modal_title__ieOeL","BlogIcon":"AddNewFile_BlogIcon__NkT9H"};